<script setup>
import { computed } from 'vue';
import Available from '@components/offer-card/labels/Available.vue';
import Contacted from '@components/offer-card/labels/Contacted.vue';
import ProposalNew from '@components/offer-card/labels/ProposalNew.vue';
import ProposalOffmarket from '@components/offer-card/labels/ProposalOffmarket.vue';
import ProposalRemoved from '@components/offer-card/labels/ProposalRemoved.vue';
import Rent from '@components/offer-card/labels/Rent.vue';
import State from '@components/offer-card/labels/State.vue';
import { isOfferDisabled } from '@organisms/offer/offer-utils';

const props = defineProps({
  offer: {
    type: Object,
    required: true,
  },
  proposal: {
    type: Object,
    default: null,
  },
  isOwnerView: {
    type: Boolean,
    default: false,
  },
  isContacted: {
    type: Boolean,
    default: false,
  },
});

const isRented = computed(() => {
  if (props.proposal) {
    return props.proposal.is_all_offers_rented;
  }

  return isOfferDisabled(props.offer);
});
</script>

<template>
  <div class="hit-labels image">
    <template v-if="isOwnerView">
      <State :offer="offer" />
    </template>
    <template v-else>
      <Available :offer="offer" />
      <Contacted v-if="isContacted" />
      <Rent :is-rented="isRented" />
      <template v-if="proposal">
        <ProposalRemoved :proposal="proposal" />
        <ProposalNew :offer="offer" />
        <ProposalOffmarket :offer="offer" />
      </template>
    </template>
  </div>
</template>
